import { Text, View } from '@react-pdf/renderer';

import styles from './Styles';

export const OrganizationBank = ({ invoice }) => (
  <View style={{ width: '50%' }}>
    <Text style={styles.subTitle}>Bank Details:</Text>
    {invoice.ourEntityBank.bankName && (
      <>
        <Text style={styles.text}>{invoice.ourEntity.Legal_Name}</Text>
        <Text style={styles.text}>
          {`${invoice.ourEntityBank.bankName ?? ''}, ` +
            `${invoice.ourEntityBank.branchName ?? ''}`}
        </Text>
        <Text style={styles.text}>Account Number: {invoice.ourEntityBank.bankAccountNumber}</Text>
        <Text style={styles.text}>SWIFT: {invoice.ourEntityBank.swiftCode}</Text>
        <Text style={styles.text}>IBAN: {invoice.ourEntityBank.iban}</Text>
      </>
    )}
  </View>
);
